"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// This is intended. This is a no-op function and intended to do nothing.
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noOp = function noOp() {};

var _default = noOp;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJub09wIl0sInNvdXJjZVJvb3QiOiJidW5kbGU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWRhcHRpdmVDYXJkcy9ET01NYW5pcHVsYXRpb25XaXRoVW5kby9wcml2YXRlL25vT3AudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gVGhpcyBpcyBpbnRlbmRlZC4gVGhpcyBpcyBhIG5vLW9wIGZ1bmN0aW9uIGFuZCBpbnRlbmRlZCB0byBkbyBub3RoaW5nLlxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1lbXB0eS1mdW5jdGlvblxuY29uc3Qgbm9PcDogKCkgPT4gdm9pZCA9ICgpID0+IHt9O1xuXG5leHBvcnQgZGVmYXVsdCBub09wO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFDQTtBQUNBLElBQU1BLElBQWdCLEdBQUcsU0FBbkJBLElBQW1CLEdBQU0sQ0FBRSxDQUFqQzs7ZUFFZUEsSSJ9